"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleChoice = void 0;
const react_1 = __importStar(require("react"));
const Dropdown_1 = require("../Dropdown");
const defaultValueSorter_1 = require("./helpers/defaultValueSorter");
const getIndexByValue_1 = require("./helpers/getIndexByValue");
const MultipleChoice_styles_1 = require("./MultipleChoice.styles");
const helpers_1 = require("../../helpers");
const View_1 = require("../../View");
const MultipleChoiceContent_1 = require("./components/MultipleChoiceContent/MultipleChoiceContent");
exports.MultipleChoice = (0, helpers_1.createUIElement)('MultipleChoice', (_a, ref) => {
    var { className, widthSize, // @Deprecated: use only size
    size, isFitControlSize = false, disabled, columnSize = 7, data, error, value, placeholder = 'Not chosen...', onChange, onMenuOpen, onMenuClose, valueSorter = defaultValueSorter_1.defaultValueSorter, titleFormatter, texts, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "widthSize", "size", "isFitControlSize", "disabled", "columnSize", "data", "error", "value", "placeholder", "onChange", "onMenuOpen", "onMenuClose", "valueSorter", "titleFormatter", "texts", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const rootRef = (0, react_1.useRef)(null);
    const buttonRef = ref || rootRef;
    const getSelected = (0, react_1.useCallback)((prevSelectedState, value) => {
        return value
            ? value.map((value) => (0, getIndexByValue_1.getIndexByValue)(data, value))
            : prevSelectedState;
    }, [data]);
    const [selected, setSelected] = (0, react_1.useState)(getSelected([], value));
    (0, react_1.useEffect)(() => {
        setSelected((prevState) => getSelected(prevState || [], value));
    }, [getSelected, value]);
    const getSortValue = (0, react_1.useCallback)((nextValue) => {
        nextValue = nextValue || value;
        return nextValue && valueSorter
            ? nextValue.sort((a, b) => valueSorter(a, b, data))
            : nextValue;
    }, [data, value, valueSorter]);
    const update = (0, react_1.useCallback)((selected) => {
        const nextValue = getSortValue(selected.map((idx) => data[idx].id)) || [];
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
        setSelected(selected);
    }, [data, getSortValue, onChange]);
    const canSelectAll = (0, react_1.useMemo)(() => () => selected.length !== data.length, [data.length, selected.length]);
    const canClearAll = (0, react_1.useMemo)(() => !!selected.length, [selected.length]);
    const onToggleItem = (0, react_1.useCallback)((index) => {
        const filteredSelected = selected.filter((i) => i !== index);
        if (filteredSelected.length === selected.length) {
            filteredSelected.push(index);
        }
        update(filteredSelected);
    }, [selected, update]);
    const onClearAll = (0, react_1.useCallback)(() => update([]), [update]);
    const onSelectAll = (0, react_1.useCallback)(() => update(data.map((_, idx) => idx)), [data, update]);
    const isSelected = (0, react_1.useCallback)((index) => selected.indexOf(index) > -1, [selected]);
    const renderTitle = (0, react_1.useMemo)(() => {
        let selectedItems = selected
            .map((idx) => {
            return data[idx] || { id: '', name: '' };
        })
            .filter((i) => !!i.name);
        if (typeof valueSorter === 'function') {
            selectedItems = selectedItems.sort((a, b) => valueSorter(a.id, b.id, data));
        }
        if (typeof titleFormatter === 'function') {
            const title = titleFormatter(selectedItems);
            if (title) {
                return title;
            }
        }
        return selectedItems.map((i) => i.name).join(', ');
    }, [data, selected, titleFormatter, valueSorter]);
    const renderContent = (0, react_1.useCallback)(() => (react_1.default.createElement(MultipleChoice_styles_1.StyledMultipleChoiceContentWrapper, { spaceHorizontal: View_1.INDENT.m, spaceVertical: View_1.INDENT.s, contentMod: View_1.VIEW_CONTENT_MOD.fill },
        react_1.default.createElement(MultipleChoiceContent_1.MultipleChoiceContent, { isSelected: isSelected, columnSize: columnSize, data: data, onClearAll: onClearAll, onSelectAll: onSelectAll, onToggleItem: onToggleItem, canSelectAll: canSelectAll(), canClearAll: canClearAll, texts: texts }))), [
        canClearAll,
        canSelectAll,
        columnSize,
        data,
        isSelected,
        onClearAll,
        onSelectAll,
        onToggleItem,
        texts
    ]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'multiplechoice-main-control', [initialDataSelectorId]);
    const hasError = (0, react_1.useMemo)(() => !disabled && error, [disabled, error]);
    const controlSize = (0, react_1.useMemo)(() => size || widthSize, [size, widthSize]);
    const renderControl = (0, react_1.useCallback)(({ button, isActive, actions: dropdownActions }) => {
        const actions = {
            open: () => {
                if (disabled || isActive) {
                    return;
                }
                dropdownActions.show();
            },
            close: () => {
                if (disabled || !isActive) {
                    return;
                }
                dropdownActions.hide();
            }
        };
        return (react_1.default.createElement(MultipleChoice_styles_1.StyledMultiChoiceButton, Object.assign({}, rest, { ref: button.ref, style: style, "data-selector-id": dataSelectorId, error: hasError, size: controlSize, isFitControlSize: isFitControlSize, active: isActive, placeholder: placeholder, text: renderTitle, disabled: disabled, onFocus: onFocus, onBlur: onBlur, onClick: onClick, onMouseDown: (e) => {
                button.onMouseDown(e);
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
            }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: (e) => {
                if (e.key === ' ' && !disabled) {
                    isActive ? actions.close() : actions.open();
                }
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
            }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-MultipleChoice', className) })));
    }, [
        className,
        controlSize,
        dataSelectorId,
        disabled,
        hasError,
        isFitControlSize,
        onBlur,
        onClick,
        onFocus,
        onKeyDown,
        onKeyPress,
        onKeyUp,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        onMouseUp,
        placeholder,
        renderTitle,
        rest,
        style
    ]);
    return (react_1.default.createElement(Dropdown_1.Dropdown, { ref: buttonRef, renderControl: renderControl, onDidShow: onMenuOpen, onDidHide: onMenuClose, renderContent: renderContent }));
});
//# sourceMappingURL=MultipleChoice.js.map